module.exports = __webpack_public_path__ + "img/company.0a82e57f.png";